"use strict";
import {createSwiper} from "./swiper";
import {onFind} from "@elements/init-modules-in-scope";
import {findIn} from '@elements/dom-utils';

export function init () {
    onFind('.js-webcam-slider', function (sliderElement) {
        createSwiper(sliderElement, {
                loop: true,
                slidesPerView: 1,
                spaceBetween: 1,
                navigation: {
                    findNextElement: swiperContainer => findIn('.js-webcam-slider__next', swiperContainer),
                    findPrevElement: swiperContainer => findIn('.js-webcam-slider__prev', swiperContainer),
                },
                breakpoints: {
                    // when window width is >= 768px
                    768: {
                        slidesPerView: 2,
                    }
                },
            },
            {
                sliderContainer: '.js-webcam-slider',
                slider: '.js-webcam-slider__slider'
            });
    });
}

